import { render, staticRenderFns } from "./QnaList.vue?vue&type=template&id=56148139&scoped=true"
import script from "./QnaList.vue?vue&type=script&lang=js"
export * from "./QnaList.vue?vue&type=script&lang=js"
import style0 from "./QnaList.vue?vue&type=style&index=0&id=56148139&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56148139",
  null
  
)

export default component.exports